import React, { useEffect } from 'react';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { Checkbox } from 'primereact/checkbox';
import { Divider } from 'primereact/divider';
import { Calendar } from 'primereact/calendar';

const InformacionGeneralSection = ({ 
    provider, 
    isEditing, 
    categorias,
    ciudades, 
    onInputChange, 
    onInputNumberChange, 
    onCheckboxChange, 
    onDropdownChange,
    onCalendarChange 
}) => {
 
    return (
        <div className="col-12">
            <Card title="Información General">
                <div className="formgrid grid">
                    {isEditing && (
                        <div className="field col-12 md:col-4">
                            <label htmlFor="id">ID</label>
                            <InputText 
                                id="id" 
                                value={provider.ID || ''} 
                                disabled 
                            />
                        </div>
                    )}

                    <div className={`field col-12 md:col-${isEditing ? '4' : '6'}`}>
                        <label htmlFor="nombre">Nombre</label>
                        <InputText 
                            id="nombre" 
                            value={provider.NOMBRE} 
                            onChange={(e) => onInputChange(e, 'NOMBRE')} 
                        />
                    </div>

                    <div className={`field col-12 md:col-${isEditing ? '4' : '6'}`}>
                        <label htmlFor="razonSocial">Razón Social</label>
                        <InputText 
                            id="razonSocial" 
                            value={provider.RAZON_SOCIAL} 
                            onChange={(e) => onInputChange(e, 'RAZON_SOCIAL')} 
                        />
                    </div>

                    <div className="field col-12 md:col-4">
                        <label htmlFor="rfc">RFC</label>
                        <InputText 
                            id="rfc" 
                            value={provider.RFC} 
                            onChange={(e) => onInputChange(e, 'RFC')} 
                        />
                    </div>

                    <div className="field col-12 md:col-4">
                        <label htmlFor="categoria">Categoría</label>
                        <Dropdown 
                            id="categoria" 
                            value={provider.CATEGORIA} 
                            options={categorias} 
                            onChange={(e) => onDropdownChange(e, 'CATEGORIA')} 
                            placeholder="Seleccione una categoría" 
                            optionLabel='name'
                        />
                    </div>

                    <div className="field col-12 md:col-4">
                        <label htmlFor="diasCredito">Días Crédito</label>
                        <InputNumber 
                            id="diasCredito" 
                            value={provider.DIAS_CREDITO} 
                            onValueChange={(e) => onInputNumberChange(e, 'DIAS_CREDITO')} 
                        />
                    </div>

                    <Divider />

                    <div className="field col-12 md:col-8">
                        <label htmlFor="direccion">Dirección</label>
                        <InputText 
                            id="direccion" 
                            value={provider.DIRECCION} 
                            onChange={(e) => onInputChange(e, 'DIRECCION')} 
                        />
                    </div>

                    <div className="field col-12 md:col-4">
                        <label htmlFor="colonia">Colonia</label>
                        <InputText 
                            id="colonia" 
                            value={provider.COLONIA} 
                            onChange={(e) => onInputChange(e, 'COLONIA')} 
                        />
                    </div>

                    <div className="field col-12 md:col-6">
                        <label htmlFor="ciudad">Ciudad</label>
                        <Dropdown 
                            id="ciudad" 
                            value={provider.CIUDAD} 
                            options={ciudades} 
                            onChange={(e) => onDropdownChange(e, 'CIUDAD')} 
                            placeholder="Seleccione una ciudad" 
                            optionLabel='name'
                        />
                    </div>

                    <div className="field col-12 md:col-3">
                        <label htmlFor="cp">CP</label>
                        <InputText 
                            id="cp" 
                            value={provider.CP} 
                            onChange={(e) => onInputChange(e, 'CP')} 
                            type='number'
                        />
                    </div>

                    <div className="field col-12 md:col-6">
                        <label htmlFor="horario">Horario</label>
                        <InputText 
                            id="horario" 
                            value={provider.HORARIO} 
                            onChange={(e) => onInputChange(e, 'HORARIO')} 
                            placeholder="Ej: Lunes a Viernes 08:00 - 17:00"
                        />
                    </div>

                    <Divider />

                    <div className="field col-12 md:col-4">
                        <label htmlFor="telefono">Teléfono</label>
                        <InputText 
                            id="telefono" 
                            value={provider.TELEFONO} 
                            onChange={(e) => onInputChange(e, 'TELEFONO')} 
                            type='number'
                        />
                    </div>

                    <div className="field col-12 md:col-4">
                        <label htmlFor="telefono2">Teléfono 2</label>
                        <InputText 
                            id="telefono2" 
                            value={provider.TELEFONO2} 
                            onChange={(e) => onInputChange(e, 'TELEFONO2')}
                              type='number' 
                        />
                    </div>

                    <div className="field col-12 md:col-4">
                        <label htmlFor="pagina">Página Web</label>
                        <InputText 
                            id="pagina" 
                            value={provider.PAGINA} 
                            onChange={(e) => onInputChange(e, 'PAGINA')} 
                        />
                    </div>

                    <div className="field col-12 md:col-4">
                        <label htmlFor="correo">Correo</label>
                        <InputText 
                            id="correo" 
                            value={provider.CORREO} 
                            onChange={(e) => onInputChange(e, 'CORREO')} 
                        />
                    </div>

                    <div className="field col-12 md:col-4">
                        <label htmlFor="contacto1">Contacto 1</label>
                        <InputText 
                            id="contacto1" 
                            value={provider.CONTACTO1} 
                            onChange={(e) => onInputChange(e, 'CONTACTO1')} 
                        />
                    </div>

                    <div className="field col-12 md:col-4">
                        <label htmlFor="contacto2">Contacto 2</label>
                        <InputText 
                            id="contacto2" 
                            value={provider.CONTACTO2} 
                            onChange={(e) => onInputChange(e, 'CONTACTO2')} 
                        />
                    </div>

                    <div className="field col-12 md:col-3">
                        <label htmlFor="odoo">ODOO</label>
                        <InputText 
                            id="odoo" 
                            value={provider.ODOO} 
                            onChange={(e) => onInputChange(e, 'ODOO')} 
                            type='number'
                        />
                    </div>

                    <div className="field-checkbox col-12 md:col-3">
                        <Checkbox 
                            inputId="activo" 
                            checked={provider.ACTIVO} 
                            onChange={(e) => onCheckboxChange(e, 'ACTIVO')} 
                        />
                        <label htmlFor="activo" className="ml-2">Activo</label>
                    </div>

                    <div className="field-checkbox col-12 md:col-3">
                        <Checkbox 
                            inputId="directorio" 
                            checked={provider.DIRECTORIO} 
                            onChange={(e) => onCheckboxChange(e, 'DIRECTORIO')} 
                        />
                        <label htmlFor="directorio" className="ml-2">Directorio</label>
                    </div>
                </div>
            </Card>
        </div>
    );
};

export default InformacionGeneralSection;
